import { gql } from '@apollo/client';

export const GET_USER_COUNSELLING_LIST = gql`
  query userCounsellingList($student_idx: Int, $teacher_idx: Int) {
    userCounsellingList(student_idx: $student_idx, teacher_idx: $teacher_idx) {
      idx
      student_idx
      teacher_idx
      title
      detail
      file
      idate
      student_name
      teacher_name
    }
  }
`;
